/* 
 *  Created by SGiri 03/14/2018
 */

import { Component, OnInit } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { AdminService } from '~admin/services/admin.service';
import { AppUtil } from '~util/app.util';
import { Constants } from '~util/app.constant';
import { ActionComponent } from '~admin/action/action.component';

@Component({
  selector: 'app-request',
  templateUrl: './request.component.html',
  styleUrls: ['./request.component.css']
})
export class RequestComponent implements OnInit {

  gridOptions: GridOptions;
  columnDefs: any[]
  rowData: Request[];
  style: {};


  constructor(private service: AdminService, private util: AppUtil) {
    this.gridOptions = util.getGridOptions('No data to show');
    this.gridOptions.enableFilter = true;
    this.columnDefs = this.getColumnDef();
    this.style = Constants.gridStyle;
  }

  ngOnInit() {

    this.getRowData();

  }

  onGridReady(params) {
    params.api.sizeColumnsToFit();
  }


  getRowData() {
    this.service.getRequests().subscribe((data: Request[]) => {
      this.rowData = data
    });
  }

  getColumnDef() {
    return [
      { headerName: "Request Id", field: "requestId" },
      { headerName: "Request Date", field: "requestDate" },
      { headerName: "Modified Date", field: "modifiedDate" },
      { headerName: "From", field: "sourceEnvironment" },
      { headerName: "To", field: "targetEnvironment" },
      { headerName: "Reports #", field: "count", valueFormatter: this.getReportsCount },
      { headerName: "Requested By", field: "requestorId" },
      { headerName: "Approver", field: "approverId" },
      { headerName: "Status", field: "status", cellClass: this.getStatusCellClass },
      { headerName: "Action", cellRendererFramework: ActionComponent, cellClass: "show-overflow" }
    ];
  }

  getReportsCount(params) {
    return params.data.requestDetails.length
  }

  getStatusCellClass(params) {

    let color = ''

    switch (params.data.status) {
      case 'DENIED':
        color = 'text-danger'
        break;

      case 'APPROVED':
        color = 'text-success'
        break;

      case 'PENDING':
        color = 'text-primary'
        break;

      default:
        break;
    }

    return color;
  }
}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/bi-admin/request/request.component.ts